import { Box, Button, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

export const NotFoundPage = () => {
	const { t } = useTranslation();

	return (
		<Wrapper>
			<Inner>
				<GlowNumber>404</GlowNumber>
				<Typography
					variant='h5'
					fontWeight={700}
					textAlign='center'
					sx={{ mt: 1, mb: 1 }}
				>
					{t('notFound.title', 'Страница не найдена')}
				</Typography>
				<Typography
					variant='body2'
					color='text.secondary'
					textAlign='center'
					sx={{ maxWidth: 340 }}
				>
					{t(
						'notFound.description',
						'Запрошенная страница не существует или была перемещена.'
					)}
				</Typography>
				<Button
					component={Link}
					to='/'
					variant='contained'
					size='large'
					startIcon={<HomeRoundedIcon />}
					sx={{ mt: 4, borderRadius: 3, px: 4, fontWeight: 700 }}
				>
					{t('notFound.goHome', 'На главную')}
				</Button>
			</Inner>
		</Wrapper>
	);
};

const Wrapper = styled(Box)(({ theme }) => ({
	minHeight: '100vh',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background:
		theme.palette.mode === 'dark'
			? theme.palette.background.default
			: alpha(theme.palette.primary.light, 0.06),
	padding: theme.spacing(3)
}));

const Inner = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center'
}));

const GlowNumber = styled(Typography)(({ theme }) => ({
	fontSize: 'clamp(96px, 20vw, 180px)',
	fontWeight: 900,
	lineHeight: 1,
	letterSpacing: '-4px',
	background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
	WebkitBackgroundClip: 'text',
	WebkitTextFillColor: 'transparent',
	backgroundClip: 'text',
	filter: `drop-shadow(0 0 32px ${alpha(theme.palette.primary.main, 0.35)})`
}));
